import { render, staticRenderFns } from "./TrulyMatterCard.vue?vue&type=template&id=7ae90b17&scoped=true"
import script from "./TrulyMatterCard.vue?vue&type=script&lang=js"
export * from "./TrulyMatterCard.vue?vue&type=script&lang=js"
import style0 from "./TrulyMatterCard.vue?vue&type=style&index=0&id=7ae90b17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae90b17",
  null
  
)

export default component.exports